"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'message.send.failed': '消息发送失败',
};
